// @flow
import { Landing } from './Landing';

export default Landing;
export { Landing };
